import { Card, Container, Form, Group, Text, useMelioForm } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { SubscriptionBillingCycleEnum } from '@melio/subscriptions-api';

type SubscriptionBillingCycleProps = {
  billingCycle: SubscriptionBillingCycleEnum;
  isPlanSaving: boolean;
  onBillingCycleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const SubscriptionBillingCycle = ({
  billingCycle,
  isPlanSaving,
  onBillingCycleChange,
}: SubscriptionBillingCycleProps) => {
  const { formatMessage } = useMelioIntl();
  const { registerField } = useMelioForm({
    onSubmit: () => null,
  });

  return (
    <Group variant="vertical" spacing="none">
      <Container paddingBottom="s">
        <Text as="h2" textStyle="body2Semi" color="neutral.darker">
          {formatMessage('activities.subscription.checkout.billingCycle.title')}
        </Text>
      </Container>

      <Card variant="flat" width="full">
        <Form.RadioGroup
          {...registerField('checkoutBillingCycle')}
          width="full"
          isDisabled={isPlanSaving}
          variant="horizontal"
          aria-label={formatMessage('activities.subscription.checkout.billingCycle.title')}
          value={billingCycle}
          onChange={onBillingCycleChange}
          options={[
            {
              mainLabelProps: { label: formatMessage('activities.subscription.checkout.billingCycle.monthly.label') },
              descriptionProps: { label: '$28 / month' },
              value: SubscriptionBillingCycleEnum.Monthly,
            },
            {
              mainLabelProps: {
                label: formatMessage('activities.subscription.checkout.billingCycle.annual.label'),
                badgeProps: {
                  label: formatMessage('activities.subscription.promotion.label'),
                  status: 'success',
                  type: 'secondary',
                },
              },
              descriptionProps: { label: '$19 / month' },
              value: SubscriptionBillingCycleEnum.Yearly,
            },
          ]}
        />
      </Card>
    </Group>
  );
};
